(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init() {
    var nav = document.querySelector('.mw-nav');
    var hero = document.querySelector('.mw-hero');
    var wrap = document.querySelector('.mw-hero__wrap');
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY || 0;
        if (nav) nav.classList.toggle('is-scrolled', y > 8);
        if (wrap && hero && !reduce) {
          var h = hero.offsetHeight || 1;
          var p = Math.max(0, Math.min(1, y / h));
          wrap.style.setProperty('--mw-p', p.toFixed(3));
        }
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    if (reduce || !('IntersectionObserver' in window)) return;
    var cards = document.querySelectorAll('.mw-card');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          var el = en.target;
          var i = Array.prototype.indexOf.call(el.parentNode.parentNode.children, el.parentNode);
          el.style.transitionDelay = (Math.max(0, i) % 4) * 90 + 'ms';
          el.classList.add('is-in');
          io.unobserve(el);
          setTimeout(function () { el.style.transitionDelay = ''; }, 1400);
        }
      });
    }, { threshold: 0.15 });
    cards.forEach(function (c) {
      var r = c.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9 && r.left < window.innerWidth) return; // already on screen: leave visible
      c.classList.add('mw-pre');
      io.observe(c);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
